import { render, staticRenderFns } from "./InvalidVerify.vue?vue&type=template&id=4d68cb7e&scoped=true"
import script from "./InvalidVerify.vue?vue&type=script&lang=ts"
export * from "./InvalidVerify.vue?vue&type=script&lang=ts"
import style0 from "./InvalidVerify.vue?vue&type=style&index=0&id=4d68cb7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d68cb7e",
  null
  
)

export default component.exports